import React, {forwardRef, useEffect, useRef, useState} from "react";
import {BufferGeometry, Mesh} from "three";
import {useLoader} from "@react-three/fiber";
import {STLLoader} from "three/examples/jsm/loaders/STLLoader";
import {adjustGeometry} from "../adjustGeometry";
import {toaster} from "./toaster";

function useAdjustedGeometry(url: string, scaleTo: number, withObjectSize?: (size: number) => void) {

  const sourceGeometry: BufferGeometry = useLoader(STLLoader, url);

  const [geometry, setGeometry] = useState<BufferGeometry | null>(null);

  const withObjectSizeRef = useRef(withObjectSize);
  withObjectSizeRef.current = withObjectSize;

  useEffect(() => {
    const {geometry, dropAxis, maxSize} = adjustGeometry(sourceGeometry, scaleTo);
    if (dropAxis) toaster.show({
      icon:    "pivot",
      message: `Geometry rotated along ${dropAxis} axis to align with grid`,
    });
    withObjectSizeRef.current?.(maxSize);
    setGeometry(geometry);
  }, [sourceGeometry, scaleTo]);

  return geometry;
}

export const StlObject = forwardRef<Mesh, {
  url: string;
  scaleTo: number;
  withObjectSize?: (size: number) => void;
}>(({url, scaleTo, withObjectSize}, ref) => {

  const geometry = useAdjustedGeometry(url, scaleTo, withObjectSize);

  return geometry ? <mesh
    ref={ref}
    castShadow
    receiveShadow
  >
    <primitive object={geometry} attach="geometry"/>
    <meshPhongMaterial color="royalblue"/>
  </mesh> : null;
});